export const OROPHistoryTypeClaim = 4;
export const ReferenceTypeGtin = 'GTIN';
export const ReferenceTypeProductIdentifier = 'IDENTIFIER';
